import { assignSafe } from '@summit/core';

export class BackEndClientAction {
  id?: string;
  api?: string;
  filter?: string | null;

  constructor(jsonData?: Partial<BackEndClientAction>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
  }
}
